import { useRouter } from '@tanstack/react-router';
import { Languages, LogOut, Monitor, Moon, Settings, Sun } from 'lucide-react';
import { Menu } from '@kidova/ui-web';
import { usePreferences } from '../app/providers';
import { useI18n } from '../i18n';
import type { AppLocale } from '../lib/preferences';
import { AccountButton } from './AccountButton';
import { useSignOut } from './AppShell';

const LANGUAGES: { code: AppLocale; name: string }[] = [
  { code: 'de', name: 'Deutsch' },
  { code: 'en', name: 'English' },
  { code: 'ar', name: 'العربية' },
];

export default function AccountMenu({ name }: { name: string }) {
  const { t } = useI18n();
  const { locale, setLocale, theme, setTheme } = usePreferences();
  const router = useRouter();
  const signOut = useSignOut();
  return (
    <Menu
      label={t('shell.account')}
      align="end"
      trigger={<AccountButton name={name} />}
      items={[
        {
          id: 'settings',
          label: t('nav.settings'),
          icon: Settings,
          onSelect: () => {
            void router.navigate({ to: '/settings' });
          },
        },
        {
          id: 'theme',
          separated: true,
          label: `${t('shell.theme')}: ${t(`shell.theme.${theme}`)}`,
          icon: theme === 'dark' ? Moon : theme === 'light' ? Sun : Monitor,
          onSelect: () => {
            setTheme(theme === 'system' ? 'light' : theme === 'light' ? 'dark' : 'system');
          },
        },
        ...LANGUAGES.filter((l) => l.code !== locale).map((l) => ({
          id: `lang-${l.code}`,
          label: l.name,
          icon: Languages,
          onSelect: () => {
            setLocale(l.code);
          },
        })),
        {
          id: 'signout',
          separated: true,
          label: t('shell.signOut'),
          icon: LogOut,
          onSelect: () => {
            void signOut();
          },
        },
      ]}
    />
  );
}
